<template>
  <div id="app">
    <Navbar v-show="!isInPurchaseView" />
    <router-view/>
    <footer class="footer">
      <div class="content has-text-centered">
        <p><a href="mailto:detectxapp@gmail.com">detectxapp@gmail.com</a></p>
        <p>&#9400;<strong>DetectX</strong> 2019</p>
      </div>
    </footer>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import helper from './helper'
export default {
  components: {
    Navbar
  },
  computed: {
    isInPurchaseView() {
      return helper.isInPurchaseView()
    }
  }
}
</script>

<style lang="scss">
@import '~bulma/bulma';
@import '~bulma-extensions/bulma-pricingtable/src/sass/index';
</style>
